// extracted by mini-css-extract-plugin
export var customBullet = "CarouselWithImage-module__customBullet--3iyS0";
export var customBulletActive = "CarouselWithImage-module__customBulletActive--moN1n";
export var customBulletContainer = "CarouselWithImage-module__customBulletContainer--Tbn9c";
export var customSwiperSlide = "CarouselWithImage-module__customSwiperSlide--3wEW9";
export var imgWrapper = "CarouselWithImage-module__imgWrapper--2znzv";
export var titleContainer = "CarouselWithImage-module__titleContainer--3pkIj";
export var wrapper = "CarouselWithImage-module__wrapper--3lGbN";